<div *ngIf="!isLoading">
	<div class="mb-xxxs br-md card">
		<div class="d-f fd-c mt-xxxs mb-nano ml-xxxs br-md" [formGroup]="prsForm">
			<div class="d-f ai-c mb-xxs">
				<span class="fs-xs fw-bold lh-xs to-ellipsis">Dados Pessoais</span>
			</div>
			<div class="d-f line">
				<mat-form-field
					class="mr-xxxs col-1"
					title="Data de nascimento"
					appearance="outline"
				>
					<mat-label>Data de nascimento</mat-label>
					<input
						matInput
						formControlName="birthday"
						id="sbd-{{ inputId }}"
						[matDatepicker]="bpicker"
						placeholder="Data de nascimento"
					/>
					<mat-datepicker-toggle matSuffix [for]="bpicker">
						<mat-icon
							matDatepickerToggleIcon
							svgIcon="sanus-calendar-blue"
						></mat-icon>
					</mat-datepicker-toggle>
					<mat-datepicker #bpicker></mat-datepicker>
					<mat-error *ngIf="prsForm.get('birthday')?.hasError('required')">
						Campo obrigatório
					</mat-error>
				</mat-form-field>
				<mat-form-field
					class="mr-xxxs col-2 mob-va"
					title="Nome da mãe"
					appearance="outline"
				>
					<mat-label>Nome da mãe</mat-label>
					<input
						type="text"
						matInput
						formControlName="mothers_name"
						id="smn-{{ inputId }}"
						placeholder="Nome da mãe"
					/>
					<mat-error *ngIf="prsForm.get('mothers_name')?.hasError('required')">
						Campo obrigatório
					</mat-error>
				</mat-form-field>
			</div>
			<div class="d-f mt-xxs line">
				<mat-form-field
					class="mr-xxxs col-1"
					title="Estado civil"
					appearance="outline"
				>
					<mat-label>Estado civil</mat-label>
					<mat-select formControlName="marital_status">
						<mat-option
							*ngFor="let maritalStatus of maritalStatusList"
							[value]="maritalStatus.value"
						>
							{{ maritalStatus.label }}
						</mat-option>
					</mat-select>
					<mat-error
						*ngIf="prsForm.get('marital_status')?.hasError('required')"
					>
						Campo obrigatório
					</mat-error>
				</mat-form-field>

				<mat-form-field
					class="mr-xxxs col-1 mob-va"
					title="Sexo"
					appearance="outline"
				>
					<mat-label>Sexo</mat-label>
					<mat-select formControlName="gender">
						<mat-option *ngFor="let gender of genders" [value]="gender">
							{{ capitalize(gender) }}
						</mat-option>
					</mat-select>
					<mat-error *ngIf="prsForm.get('gender')?.hasError('required')">
						Campo obrigatório
					</mat-error>
				</mat-form-field>
			</div>
		</div>
	</div>
	<div class="mb-xxxs br-md card">
		<div class="d-f fd-c mt-xxxs mb-nano ml-xxxs br-md" [formGroup]="addForm">
			<div class="d-f ai-c mb-xxs">
				<span class="fs-xs fw-bold lh-xs to-ellipsis">
					Endereço do beneficiário
				</span>
			</div>
			<div class="d-f ai-c line">
				<mat-form-field class="mr-xs col-1" title="CEP" appearance="outline">
					<mat-label>CEP</mat-label>
					<input
						type="text"
						matInput
						mask="00000-000"
						formControlName="postal_code"
						id="spc-{{ inputId }}"
						placeholder="CEP"
						(blur)="onCepBlur()"
					/>
					<mat-error
						*ngIf="
							addForm.get('postal_code')?.hasError('pattern') &&
							!addForm.get('postal_code')?.hasError('required')
						"
					>
						Digite um CEP válido
					</mat-error>
					<mat-error *ngIf="addForm.get('postal_code')?.hasError('required')">
						É necessário digitar o CEP
					</mat-error>
				</mat-form-field>
				<a
					class="pb-xxxs mob-va"
					href="https://buscacepinter.correios.com.br/app/endereco/index.php"
					target="_blank"
				>
					Não sei o CEP
				</a>
			</div>
			<div class="d-f mt-xxs line">
				<mat-form-field class="col-2" title="Endereço" appearance="outline">
					<mat-label>Endereço</mat-label>
					<input
						type="text"
						matInput
						formControlName="street"
						id="sph-{{ inputId }}"
						placeholder="Endereço"
					/>
					<mat-error *ngIf="addForm.get('street')?.hasError('required')">
						O endereço é obrigatório
					</mat-error>
				</mat-form-field>
				<mat-form-field
					class="ml-xxxs mr-xxxs col-1 mob-va"
					title="Número"
					appearance="outline"
				>
					<mat-label>Número</mat-label>
					<input
						type="text"
						matInput
						formControlName="number"
						id="san-{{ inputId }}"
						placeholder="Número"
					/>
					<mat-error *ngIf="addForm.get('number')?.hasError('required')">
						O número é obrigatório
					</mat-error>
				</mat-form-field>
			</div>
			<div class="d-f mt-xxs line">
				<mat-form-field
					class="col-1 dyn"
					title="Complemento"
					appearance="outline"
				>
					<mat-label>Complemento (opcional)</mat-label>
					<input
						type="text"
						matInput
						placeholder="Complemento (opcional)"
						formControlName="complement"
						id="snc-{{ inputId }}"
					/>
				</mat-form-field>
				<mat-form-field
					class="ml-xxxs col-1 dyn mob-va"
					title="Bairro"
					appearance="outline"
				>
					<mat-label>Bairro</mat-label>
					<input
						type="text"
						matInput
						formControlName="neighborhood"
						id="san-{{ inputId }}"
						placeholder="Bairro"
					/>
					<mat-error *ngIf="addForm.get('neighborhood')?.hasError('required')">
						O bairro é obrigatório
					</mat-error>
				</mat-form-field>
				<mat-form-field
					class="ml-xxxs mr-xxxs col-1 dyn mob-va"
					title="Estado"
					appearance="outline"
				>
					<mat-label>Estado</mat-label>
					<mat-select formControlName="state">
						<mat-option
							*ngFor="let s of uf"
							[value]="s.uf"
							(click)="onUfChange(s.id, 'address')"
						>
							{{ s.label }}
						</mat-option>
					</mat-select>
				</mat-form-field>
			</div>
			<div class="d-f mt-xxs line">
				<mat-form-field class="col-1" title="Cidade" appearance="outline">
					<mat-label>Cidade</mat-label>
					<input
						type="text"
						matInput
						formControlName="city"
						id="sph-{{ inputId }}"
						placeholder="Cidade"
						*ngIf="!auxStateForm"
					/>
					<mat-select formControlName="city" *ngIf="auxStateForm">
						<mat-option [value]="null">Cidade</mat-option>
						<mat-option *ngFor="let city of cities" [value]="city">
							{{ city }}
						</mat-option>
					</mat-select>
				</mat-form-field>
			</div>
		</div>
	</div>
	<div class="mb-xxxs br-md card">
		<div class="d-f fd-c mt-xxxs mb-nano ml-xxxs br-md" [formGroup]="prfForm">
			<div class="d-f ai-c mb-xxs">
				<span class="fs-xs fw-bold lh-xs to-ellipsis">Dados profissionais</span>
			</div>
			<div class="d-f line">
				<mat-form-field
					class="mr-xxxs col-1"
					title="Data de admissão"
					appearance="outline"
				>
					<mat-label>Data de admissão</mat-label>
					<input
						matInput
						formControlName="admission_date"
						id="sad-{{ inputId }}"
						[matDatepicker]="apicker"
						placeholder="Data de admissão"
					/>
					<mat-datepicker-toggle matSuffix [for]="apicker">
						<mat-icon
							matDatepickerToggleIcon
							svgIcon="sanus-calendar-blue"
						></mat-icon>
					</mat-datepicker-toggle>
					<mat-datepicker #apicker></mat-datepicker>
					<mat-error
						*ngIf="prfForm.get('admission_date')?.hasError('required')"
					>
						Campo obrigatório
					</mat-error>
				</mat-form-field>
				<mat-form-field
					class="mr-xxxs col-1 mob-va"
					title="Data de inclusão no plano"
					appearance="outline"
				>
					<mat-label>
						{{
							prfForm.get('plan_inclusion_date')?.hasError('required')
								? '*'
								: ''
						}}
						Data de inclusão no plano
					</mat-label>
					<input
						matInput
						formControlName="plan_inclusion_date"
						id="sid-{{ inputId }}"
						[matDatepicker]="ipicker"
						placeholder="{{
							prfForm.get('plan_inclusion_date')?.hasError('required')
								? '*'
								: ''
						}} Data de inclusão no plano"
					/>
					<mat-datepicker-toggle matSuffix [for]="ipicker">
						<mat-icon
							matDatepickerToggleIcon
							svgIcon="sanus-calendar-blue"
						></mat-icon>
					</mat-datepicker-toggle>
					<mat-datepicker #ipicker></mat-datepicker>
					<mat-error
						*ngIf="prfForm.get('plan_inclusion_date')?.hasError('required')"
					>
						Campo obrigatório
					</mat-error>
				</mat-form-field>
			</div>
			<div class="d-f mt-xxs line">
				<mat-form-field
					class="mr-xxxs col-2"
					title="Cargo"
					appearance="outline"
				>
					<mat-label>Cargo</mat-label>
					<mat-select formControlName="position_id">
						<mat-option *ngFor="let pos of positions" [value]="pos.id">
							{{ pos.name }}{{ pos.city || pos.state ? ' - ' : ''
							}}{{ pos.city ? pos.city : ''
							}}{{ pos.city && pos.state ? '-' : ''
							}}{{ pos.state ? pos.state : '' }}
						</mat-option>
					</mat-select>
					<mat-error *ngIf="prfForm.get('position_id')?.hasError('required')">
						Campo obrigatório
					</mat-error>
				</mat-form-field>
			</div>
			<div class="d-f mt-xxs line">
				<mat-form-field
					class="mr-xxxs col-1 mob-va"
					title="Salário"
					appearance="outline"
				>
					<mat-label>Salário</mat-label>
					<input
						type="text"
						matInput
						mask="separator.2"
						decimalMarker=","
						thousandSeparator="."
						placeholder="Salário"
						formControlName="wage"
						id="sbw-{{ inputId }}"
					/>
				</mat-form-field>
				<mat-form-field
					class="mr-xxxs col-1 dyn mob-va"
					title="Matrícula"
					appearance="outline"
				>
					<mat-label>Matrícula</mat-label>
					<input
						type="text"
						matInput
						formControlName="registration"
						id="sbr-{{ inputId }}"
						placeholder="Matrícula"
					/>
					<mat-error *ngIf="prfForm.get('registration')?.hasError('required')">
						Campo obrigatório
					</mat-error>
				</mat-form-field>
			</div>
		</div>
	</div>
	<div class="mb-xxxs br-md card">
		<div class="d-f fd-c mt-xxxs mb-nano ml-xxxs br-md" [formGroup]="wAddForm">
			<div class="d-f ai-c mb-xxs">
				<span class="fs-xs fw-bold lh-xs to-ellipsis">Local de trabalho</span>
			</div>
			<div class="d-f line">
				<mat-form-field
					class="mr-xxxs col-1 dyn"
					title="Estado"
					appearance="outline"
				>
					<mat-label>Estado</mat-label>
					<mat-select formControlName="state">
						<mat-option
							*ngFor="let s of uf"
							[value]="s.uf"
							(click)="onUfChange(s.id, 'work')"
						>
							{{ s.label }}
						</mat-option>
					</mat-select>
					<mat-error *ngIf="wAddForm.get('state')?.hasError('required')">
						Campo obrigatório
					</mat-error>
				</mat-form-field>
				<mat-form-field
					class="col-1 mob-va"
					title="Cidade"
					appearance="outline"
				>
					<mat-label>Cidade</mat-label>
					<input
						type="text"
						matInput
						formControlName="city"
						id="sph-{{ inputId }}"
						placeholder="Cidade"
						*ngIf="!auxStateForm2"
					/>
					<mat-select formControlName="city" *ngIf="auxStateForm2">
						<mat-option [value]="null">Cidade</mat-option>
						<mat-option *ngFor="let city of auxCities" [value]="city">
							{{ city }}
						</mat-option>
					</mat-select>
					<mat-error *ngIf="wAddForm.get('city')?.hasError('required')">
						Campo obrigatório
					</mat-error>
				</mat-form-field>
			</div>
		</div>
	</div>
	<div class="mb-xxxs br-md card">
		<div class="d-f fd-c mt-xxxs mb-nano ml-xxxs br-md">
			<div class="d-f ai-c mb-xxs">
				<span class="fs-xs fw-bold lh-xs to-ellipsis">Dependentes</span>
			</div>
			<p class="mb-xs gray">
				Dependentes poderão ser adicionados em outro momento
			</p>
			<div
				class="d-f jc-sb ai-c w-100 mt-xxxs mb-xxxs"
				*ngFor="let dep of dependents; let index = index"
			>
				<p>
					{{ dep.name }} ({{ getDepType(dep.typeKinship ?? dep.type ?? '') }})
				</p>
				<div
					class="d-f jc-c ai-c mr-nano c-p squared"
					[matMenuTriggerFor]="menu"
				>
					<mat-icon svgIcon="sanus-more-blue"></mat-icon>
				</div>
				<mat-menu #menu="matMenu">
					<button mat-menu-item (click)="onEditDependent(dep, index)">
						Editar
					</button>
					<button mat-menu-item (click)="onDeleteDependent(index)">
						Excluir
					</button>
				</mat-menu>
			</div>
			<div class="d-f mt-xxs mb-xxxs line">
				<button mat-flat-button color="primary" (click)="onAddDependent()">
					Adicionar dependente
				</button>
			</div>
		</div>
	</div>
	<div class="d-f jc-fe mb-huge">
		<button
			mat-flat-button
			color="primary"
			[disabled]="disabledSaveBtn()"
			(click)="onSubmit()"
		>
			Salvar
		</button>
	</div>
</div>
<div class="d-f jc-c ai-c w-100 mt-giant loader" *ngIf="isLoading">
	<mat-spinner diameter="20"></mat-spinner>
</div>
